import styles from './Footer.module.css';
import {translations} from './../i18/translations.js';

const Footer = ({lang}) => {
    return (
            <div className={styles['footer']}>
                <p>&copy; {new Date().getFullYear()} <b>{translations[lang].mbkegy}</b> - {translations[lang].allrightsreserved}!</p>
                <p>{translations[lang].mbkegy_address}</p>
            </div>
            );
};

export default Footer